import ApiService from './ApiService';

const BASE_URL = `${ApiService.BACKEND_URL}/authz/ops-api/entity-permissions`;

class ExternalEntityService {
  /**
   * Method for fetching external entity role assignments
   * @param {string} authToken - authentication bearer token
   * @param {number} roleId - id of the role
   */
  static getExternalEntityRoleAssignments(authToken, roleId) {
    return ApiService.ApiCallAuth(
      'GET',
      `${BASE_URL}?roleId=${roleId}`,
      authToken,
      'application/json'
    );
  }

  /**
   * Method for adding external entity role assignments
   * @param {string} authToken - authentication bearer token
   * @param {object} data - data for create
   */
  static addExternalEntityRoleAssignments(authToken, data) {
    return ApiService.ApiCallBody('POST', BASE_URL, data, authToken, 'application/json');
  }

  /**
   * Method for deleting external entity role assignment
   * @param {string} authToken - authentication bearer token
   * @param {number} id - id of the assignment to delete
   */
  static deleteExternalEntityRoleAssignment(authToken, id) {
    return ApiService.ApiCallAuth('DELETE', `${BASE_URL}/${id}`, authToken, 'application/json');
  }
}

export default ExternalEntityService;
